module.exports = __webpack_public_path__ + "static/img/3.aedd712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/3.jpg
// module id = 55zN
// module chunks = 1